import { useClusterRCFAnalysisStore } from 'store/clusterRCFAnalysis.store';

import classes from 'components/common/PageContainer/clusterRCFContainer.module.scss';

import { AutomatedClusteringSelection } from 'components/pages/DurationForecastPage/components/DurationForecastFilter/components/AutomatedClusteringSelection/AutomatedClusteringSelection';
import { CustomClusteringSelection } from 'components/pages/DurationForecastPage/components/DurationForecastFilter/components/CustomClusteringSelection/CustomClusteringSelection';
import { ToggleClusteringOption } from 'components/pages/DurationForecastPage/components/DurationForecastFilter/components/ToggleClusteringOption/ToggleClusteringOption';

export const DurationForecastFilter = () => {
    const isAutomatedClusteringOption = useClusterRCFAnalysisStore((store) => store.isAutomatedClusteringOption);

    return (
        <div className={classes.clusterRCFAnalysisContainer}>
            <ToggleClusteringOption />

            {isAutomatedClusteringOption ? <AutomatedClusteringSelection /> : <CustomClusteringSelection />}
        </div>
    );
};
